/** Stable fragment id. Diacritics are stripped so Företagshälsa becomes foretagshalsa. */
export function headingAnchor(text: string): string {
  const stripped = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const slug = stripped
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug || 'section';
}
